import React from 'react';

export default function arrowRight() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.29004 5.31918L9.88004 9.90918L5.29004 14.4992L6.71004 15.9092L12.71 9.90918L6.71004 3.90918L5.29004 5.31918Z"
        fill="currentColor"
      />
    </svg>
  );
}
